/**
 * 公司文档  api
 */
import * as API from '../'

export default {
  /**
   * 公司文档列表
   */
  enterpriseFileList: params => {
    return API.GET(`/clouddo-tranning/tranning/enterprise/file/page_list`, params)
  },
  /**
   * 文档详情
   */
  enterpriseFiledetails: params => {
    return API.GET(`/clouddo-tranning/tranning/enterprise/file/details`, params)
  },
  /**
   * 保存文档
   */
  enterpriseFileSave: params => {
    return API.POST(`/clouddo-tranning/tranning/enterprise/file/save`, params)
  },
  /**
   * 删除文档数据
   */
  enterpriseFileDelete: params => {
    return API.POST(`/clouddo-tranning/tranning/enterprise/file/delete`, params)
  },
  /**
   * 修改企业文件名称 （重命名）
   * @param params
   * @returns {Promise<*>}
   */
  enterpriseFileRName: params => {
    return API.POST(`/clouddo-tranning/tranning/enterprise/file/rname`, params)
  },
  //  fiel export start

  /**
   * 静态文件导出
   */
  exportStatic: params => {
    return API.GETBLOB(`/clouddo-tranning/tranning/enterprise/file/export/static_file`, params)
  },
  /**
   * 导出明确安全教育部门红头文件
   */
  exportSecuritySupervisor: params => {
    return API.GET(`/clouddo-tranning/tranning/enterprise/file/export/security_supervisor`, params)
  },
  /**
   * 导出明确安全教育部门红头文件
   */
  exportSecurityTrainingCosts: params => {
    return API.GETBLOB(`/clouddo-tranning/tranning/enterprise/file/export/security_training_costs`, params)
  },
  /**
   * 年度安全培训教育管理台账
   */
  exportAnnualTrainingLedger: params => {
    return API.GETBLOB(`/clouddo-tranning/tranning/enterprise/file/export/annual_training_ledger`, params)
  },
  /**
   * 年度安全培训教育计划 导出
   */
  exportAnnualSafetyTrainingPlan: params => {
    return API.GETBLOB(`/clouddo-tranning/tranning/enterprise/file/export/annual_safety_training_plan`, params)
  }
  //  fiel export end
}



// WEBPACK FOOTER //
// ./src/api/new/ent_file.js